module.exports = __webpack_public_path__ + "static/media/Trapp.2186b424.png";